import { Popover } from "@mantine/core";

export const popoverComponentSettings = Popover.extend({
  defaultProps: {
    shadow: "md",
  },
});
